import {Button, Grid2} from '@mui/material';
import {RhfTextField} from 'mui-rhf-integration';
import type {ReactNode} from 'react';
import {useFormContext} from 'react-hook-form';

const OnBoardingForm = (): ReactNode => {
    const {control} = useFormContext();

    return (
        <Grid2 container spacing={2}>
            <Grid2 size={6} sx={{p: 1}}>
                <RhfTextField label='First Name' control={control} name='firstName' />
            </Grid2>
            <Grid2 size={6} sx={{p: 1}}>
                <RhfTextField label='Last Name' control={control} name='lastName' />
            </Grid2>
            <Grid2 size={12} sx={{p: 1}}>
                <Button type='submit'>Submit</Button>
            </Grid2>
        </Grid2>
    );
};

export default OnBoardingForm;
